var _BRAND_ATTRIBUTES;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var BIRMINGHAM_MIDSHIRES = 'birmingham-midshires';
export var BLACK_HORSE = 'black-horse';
export var BOS = 'bos';
export var HALIFAX = 'halifax';
export var LLOYDS = 'lloyds';
export var LLOYDS2022 = 'lloyds-2022';
export var LLOYDS2023 = 'lloyds-2023';
export var MBNA = 'mbna';
export var SCOTTISH_WIDOWS = 'scottish-widows';
export var WHITE_LABEL_LIGHT = 'white-label-light';
export var WHITE_LABEL_DARK = 'white-label-dark';
export var BRAND_ATTRIBUTES = (_BRAND_ATTRIBUTES = {}, _defineProperty(_BRAND_ATTRIBUTES, BIRMINGHAM_MIDSHIRES, {
  TITLE: 'Birmingham Midshires'
}), _defineProperty(_BRAND_ATTRIBUTES, BLACK_HORSE, {
  TITLE: 'Black Horse'
}), _defineProperty(_BRAND_ATTRIBUTES, BOS, {
  TITLE: 'Bank of Scotland'
}), _defineProperty(_BRAND_ATTRIBUTES, HALIFAX, {
  TITLE: 'Halifax'
}), _defineProperty(_BRAND_ATTRIBUTES, LLOYDS2022, {
  TITLE: 'Lloyds Bank'
}), _defineProperty(_BRAND_ATTRIBUTES, LLOYDS2023, {
  TITLE: 'Lloyds Bank'
}), _defineProperty(_BRAND_ATTRIBUTES, LLOYDS, {
  TITLE: 'Lloyds Bank'
}), _defineProperty(_BRAND_ATTRIBUTES, MBNA, {
  TITLE: 'MBNA'
}), _defineProperty(_BRAND_ATTRIBUTES, SCOTTISH_WIDOWS, {
  TITLE: 'Scottish Widows'
}), _defineProperty(_BRAND_ATTRIBUTES, WHITE_LABEL_LIGHT, {
  TITLE: 'White label (light)'
}), _defineProperty(_BRAND_ATTRIBUTES, WHITE_LABEL_DARK, {
  TITLE: 'White label (dark)'
}), _defineProperty(_BRAND_ATTRIBUTES, "default", {
  TITLE: 'Lloyds Banking Group'
}), _BRAND_ATTRIBUTES);
export var getAttributeForBrand = function getAttributeForBrand(brand, key) {
  return (
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    BRAND_ATTRIBUTES[brand] && BRAND_ATTRIBUTES[brand][key]
  );
};

// prettier-ignore
// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
export var getPossibleBrandAttributeValues = function getPossibleBrandAttributeValues(attributeKey) {
  return Object.keys(BRAND_ATTRIBUTES).map(function (brand) {
    return BRAND_ATTRIBUTES[brand][attributeKey];
  });
};
export default [BIRMINGHAM_MIDSHIRES, BLACK_HORSE, BOS, HALIFAX, LLOYDS, LLOYDS2023, LLOYDS, MBNA, SCOTTISH_WIDOWS];